<template>
  <div style="background-color: rgb(245, 245, 245);;"
    class="animate__animated animate__fadein animate__delay-0.5s animate__slower">
    <navStudent></navStudent>
    <div style="height: 100%;width: .3229rem;background: rgb(1, 162, 153);position: fixed;top: 0;left: 0;"></div>
    <div
      style="width: .7292rem;height: .1094rem;margin: .2083rem 0 .0573rem 1.0417rem;color: rgb(0, 0, 0);;font-family: Microsoft YaHei;;font-size: .0833rem;;font-weight: 400;;line-height: .1094rem;;">
      学君教育>寻找家教</div>
    <div style="display: flex;width: 7.2917rem;margin: 0 auto ;background: rgb(255, 255, 255);height: 1.9125rem;">
      <img src="../../assets/filterline.png" alt="">
      <div class="filter">
        <div>
          <span class="title">求教年级:</span>
          <el-radio-group v-model="grade">
            <el-radio-button v-for="item in  gradeList " :key="item.value" :label="item.value">{{ item.label
            }}</el-radio-button>
          </el-radio-group>
        </div>
        <div>
          <el-radio-group v-model="subject"> <span class='title'>求教科目:</span>
            <el-radio-button v-for=" item  in  subjectList " :key="item.value" :label="item.value">{{ item.label
            }}</el-radio-button>
          </el-radio-group>
        </div>
        <div style="display: flex;">
          <span class='title' style="width: .39rem;transform: translateY(.04rem);">授课区域:</span>
          <el-radio-group v-model="area">
            <el-radio-button v-for=" item  in  areaList " :key="item.value" :label="item.value">{{ item.label
            }}</el-radio-button>
          </el-radio-group>
        </div>
        <div>
          <div style="display: flex;"><span class='title'
              style="width: .72rem; transform: translateY(.04rem);">老师高校:</span>
            <el-radio-group v-model="college">
              <el-radio-button v-for=" item  in  collegelist " :key="item.value" :label="item.value">{{ item.label
              }}</el-radio-button>
            </el-radio-group>
          </div>

        </div>
        <div>
          <span class='title'>辅导方式:</span>
          <el-radio-group v-model="methods">
            <el-radio-button v-for=" item  in  methodsList " :key="item.value" :label="item.value">{{ item.label
            }}</el-radio-button>
          </el-radio-group>
        </div>
        <!-- <div>

          <el-radio-group v-model="school"><span class='title'>所在高校:</span>
            <el-radio-button v-for="item in schoolList" :key="item" :label="item"></el-radio-button>
          </el-radio-group>
        </div> -->
        <div>

          <el-radio-group v-model="degree"> <span class='title'>学历要求:</span>
            <el-radio-button v-for=" item  in  degreeList " :key="item.value" :label="item.value">{{ item.label
            }}</el-radio-button>
          </el-radio-group>
        </div>
        <div>
          <span class='title'>教师性别:</span>
          <el-radio-group v-model="sex">
            <el-radio-button v-for=" item  in  sexList " :key="item.value" :label="item.value">{{ item.label
            }}</el-radio-button>
          </el-radio-group>
        </div>
      </div>
    </div>
    <div class="total">
      <div
        style="width: 7.2917rem;height:auto;display: flex;justify-content: space-between; margin: 0 auto; flex-wrap: wrap;overflow: hidden;"
        id="findT">
        <el-empty description="暂无对应的教师" v-if="currentitems.length == 0" style="margin: 0 auto;"></el-empty>
        <div class="box" v-for=" item  in  currentitems " :key="item.tid">
          <div class="inner">
            <div class="left">
              <img :src="'https://www.cdjjwang.com/' + item.avatar" alt="">
              <div class="name">{{ item.name }}</div>
            </div>
            <div class="right">
              <div class="time"><img src="../../assets/indexFTboxtimer.png" alt="">累计授课{{ item.classHours }}h
              </div>
              <div class="card">
                <div>{{ item.university }}</div>
                <div>{{ teachertype[item.isCollegeStudent] }}</div>
              </div>
              <div class="txt">{{ item.selfEvaluation }}</div>
              <button @click="$router.push('studentlook#' + item.tid)">查看详情</button>
            </div>
          </div>
        </div>
      </div>
      <div class="pagination" id="fen" v-if="currentitems.length !== 0">
        <!-- <div class="first" @click="pageindex = 1">首页</div> -->
        <el-pagination layout="prev, pager, next" :total="total" :page-size="9" :current-page="parseInt(pageindex)"
          :pager-count="7" @current-change="change" :key="pageindex">
        </el-pagination>
        <!-- <div class=" first" @click="pageindex = totalpages">尾页
      </div> -->
        <div class="txt">前往</div>
        <input type="text" v-model.lazy="pageindex">
        <div class="txt2">页</div>
      </div>
    </div>
  </div>
</template>
<style></style>
<script>
import navStudent from '../layout/nav-student.vue';
export default {
  components: {
    navStudent,
  },
  data() {
    return {
      college: 999,
      collegelist: [{
        value: 999,
        label: '不限'
      },
      {
        value: '四川大学',
        label: '四川大学'
      }, {
        value: '⻄南交通大学',
        label: '⻄南交通大学'
      }, {
        value: '电⼦科技大学',
        label: '电⼦科技大学'
      }, {
        value: '⻄南⽯油大学',
        label: '⻄南⽯油大学'
      }, {
        value: '成都理⼯大学',
        label: '成都理⼯大学'
      }, {
        value: '四川师范大学',
        label: '四川师范大学'
      }, {
        value: '⻄南财经大学',
        label: '⻄南财经大学'
      }, {
        value: '四川农业大学',
        label: '四川农业大学'
      }, {
        value: '成都信息⼯程大学',
        label: '成都信息⼯程大学'
      }, {
        value: '⻄华大学',
        label: '⻄华大学'
      }, {
        value: '⻄南⺠族大学',
        label: '⻄南⺠族大学'
      }, {
        value: '成都大学',
        label: '成都大学'
      }, {
        value: '成都师范学院',
        label: '成都师范学院'
      }, {
        value: '成都中医药大学',
        label: '成都中医药大学'
      }, {
        value: '成都体育学院',
        label: '成都体育学院'
      }, {
        value: '四川⾳乐学院',
        label: '四川⾳乐学院'
      }, {
        value: '四川旅游学院',
        label: '四川旅游学院'
      }, {
        value: '成都东软学院',
        label: '成都东软学院'
      }, {
        value: '四川外国语大学成都学院',
        label: '四川外国语大学成都学院'
      }, {
        value: '成都锦城学院',
        label: '成都锦城学院'
      },
      {
        'value': '电⼦科技大学成都学院',
        'label': '电⼦科技大学成都学院'
      }
      ],
      totalitems: [],
      total: 0,
      teachertype: ['专职教师', '在读本科生', '在读研究生'],
      pageindex: 1,
      // gradeList: ['不限', '小学', '初中', '高中',],
      gradeList: [{
        value: 999,
        label: '不限'
      }
        , {
        value: 0,
        label: '小学'
      },
      {
        value: 1,
        label: '初中'
      },
      {
        value: 2,
        label: '高中'
      },],
      grade: 999,
      // subjectList: ['不限', '语文', '数学', '英语', '物理', '化学', '生物', '政治', '历史', '地理', '计算机', '小语种', '艺体类'],
      subjectList: [{
        value: 999,
        label: '不限'
      },
      {
        value: 1,
        label: '语文'
      },
      {
        value: 2,
        label: '数学'
      },
      {
        value: 3,
        label: '英语'
      },
      {
        value: 4,
        label: '物理'
      },
      {
        value: 5,
        label: '化学'
      },
      {
        value: 6,
        label: '生物'
      },
      {
        value: 7,
        label: '政治'
      },
      {
        value: 8,
        label: '历史'
      },
      {
        value: 9,
        label: '地理'
      },
      {
        value: 10,
        label: '计算机'
      },
      {
        value: 11,
        label: '小语种'
      },
      {
        value: 12,
        label: '艺体类'
      },],
      subject: 999,
      area: 999,
      areaList: [{
        value: 999,
        label: '不限'
      },
      {
        value: 0,
        label: '锦江区'
      }, {
        value: 1,
        label: '金牛区'
      }, {
        value: 2,
        label: '武侯区'
      }, {
        value: 3,
        label: '青羊区'
      }, {
        value: 4,
        label: '成华区'
      }, {
        value: 5,
        label: '高新区'
      }, {
        value: 6,
        label: '天府新区'
      }, {
        value: 7,
        label: '新都区'
      }, {
        value: 8,
        label: '郫都区'
      }, {
        value: 9,
        label: '双流区'
      }, {
        value: 10,
        label: '龙泉驿区'
      }, {
        value: 11,
        label: '温江区'
      }, {
        value: 13,
        label: '都江堰'
      }, {
        value: 14,
        label: '彭州'
      }, {
        value: 15,
        label: '邛崃'
      }, {
        value: 16,
        label: '崇州'
      }, {
        value: 17,
        label: '简阳'
      }, {
        value: 18,
        label: '金堂'
      }, {
        value: 19,
        label: '大邑'
      }, {
        value: 20,
        label: '蒲江'
      }, {
        value: 21,
        label: '新津'
      }, {
        value: 22,
        label: '青白江'
      },
      {
        value: 12,
        label: '其他'
      },
      ],
      methods: 999,
      // methodsList: ['不限', '老师上门', '线上辅导'],
      methodsList: [{
        value: 999,
        label: '不限',
      }, {
        value: 0,
        label: '老师上门',
      },
      {
        value: 1,
        label: '线上辅导',
      }],
      degree: 999,
      // degreeList: ['不限', '本科生', '研究生', '博士生', '教培行业在职老师', '非教培行业专职老师'],
      degreeList: [{
        value: 999,
        label: '不限'
      }, {
        value: 1,
        label: '本科生'
      }
        , {
        value: 2,
        label: '研究生'
      },
      {
        value: 3,
        label: '专职教师'
      },

      ],
      sex: 999,
      // sexList: ['不限', '男学员', '女学员'],
      sexList: [{
        value: 999,
        label: '不限'
      },
      {
        value: 1,
        label: '男教师'
      },
      {
        value: 2,
        label: '女教师'
      },],
      // school: ['不限'],
      // schoolList: ['不限', '四川大学', '西南交通大学', '电子科技大学', '西南石油大学', '成都理工大学', '四川师范大学', '西南财经大学', '四川农业大学', '成都信息工程大学', '西华大学', '西南民族大学', '成都大学', '成都师范学院', '成都中医药大学', '成都体育学院', '四川音乐学院', '四川旅游学院', '成都东软学院', '四川外国语大学成都学院', '四川大学锦城学院', '省外名校']
      currentitems: [],
      Authorization: '',
    }
  },
  methods: {
    change(index) {
      this.pageindex = index
    },
    changedata() {
      let newdata = {}
      if (this.sex != 999) {
        newdata.gender = this.sex
      }
      if (this.grade != 999) {
        newdata.gradeId = this.grade
      }
      if (this.subject != 999) {
        newdata.itemId = this.subject
      }
      if (this.area != 999) {
        newdata.areaId = this.area
      }
      if (this.methods != 999) {
        newdata.isOnline = this.methods
      }
      if (this.degree != 999) {
        newdata.teacherType = this.degree
      }
      if (this.subject == 10) {
        newdata.gradeId = 6
        delete newdata.itemId;
      }
      if (this.subject == 11) {
        newdata.gradeId = 3
        delete newdata.itemId;
      }
      if (this.subject == 12) {
        newdata.gradeId = 4
        delete newdata.itemId;
      }
      if
        (this.college != 999) {
        newdata.college = this.college
      }
      console.log(newdata);
      this.$http.get('/Api/Parent/Web//Teachers', {
        params: {
          ...newdata,
          pageSize: 9,
          pageNumber: this.pageindex
        },
        headers: {
          'Authorization': this.Authorization
        }
      }).then(res => {
        let alldata = res.data.data.records
        this.total = res.data.data.total
        this.currentitems = alldata
      })
    }
  },
  created() {
    this.Authorization = localStorage.getItem('Authorization')
    this.$http.get('/Api/Parent/Web//Teachers', {
      params: {
        pageNumber: 1,
        pageSize: 9,
      },
      headers: {
        'Authorization': this.Authorization
      }
    }).then(res => {
      console.log(res.data.data.records);
      let alldata = res.data.data.records
      this.total = res.data.data.total
      this.currentitems = alldata
    })
  },
  watch: {
    pageindex(n, o) {
      if (n !== o) {
        if (isNaN(parseInt(n))) {
          this.$message({
            message: '请输入数字',
            type: 'warning'
          });
          this.pageindex = o
          return false
        }
        if (n > Math.ceil(this.total / 9) || n < 1) {
          this.$message({
            message: '您输入的范围不对哦~~',
            type: 'warning'
          });
          this.pageindex = o
          return false
        }
        this.pageindex = n
        this.$http.get('/Api/Parent/Web//Teachers', {
          params: {
            pageNumber: n,
            pageSize: 9,
          },
          headers: {
            'Authorization': this.Authorization
          }
        }).then(res => {
          this.currentitems = Array.from(res.data.data.records)
        })
      }
    },
    subject(n, o) {
      // let a = [];
      // if (this.subject.length > 1 && JSON.stringify(n) !== JSON.stringify(o)) {
      //   if (this.subject[this.subject.length - 1] != '不限') {
      //     this.subject.forEach((item) => {
      //       if (item != '不限') {
      //         a.push(item)
      //       }
      //     })
      //     this.$set(this, 'subject', a)
      //   }
      //   else {
      //     this.$set(this, 'subject', ['不限'])
      //   }
      // }
      this.changedata()
    },
    degree(n, o) {
      // let a = [];
      // if (this.degree.length > 1 && JSON.stringify(n) !== JSON.stringify(o)) {
      //   if (this.degree[this.degree.length - 1] != '不限') {
      //     this.degree.forEach((item) => {
      //       if (item != '不限') {
      //         a.push(item)
      //       }
      //     })
      //     this.degree = a
      //   }
      //   else {
      //     this.degree = ['不限']
      //   }
      // }
      this.changedata()
    },
    sex() {
      this.changedata()
    },
    grade() {
      this.changedata()
    },
    area() {
      this.changedata()
    },
    methods() {
      this.changedata()
    },
    college() {
      this.changedata()
    }


  },

}
</script>

<style scoped>
#fen /deep/ .el-pager .active {
  background: rgb(1, 162, 153);
  color: rgb(255, 255, 255);
}

#fen /deep/ .el-pager .number {
  /* 页1 */
  width: 35px;
  height: 35px;
  border-radius: 4px;
  font-family: Noto Sans SC;
  font-size: 15px;
  font-weight: 400;
  line-height: 35px;
  letter-spacing: 0px;
  text-align: center;
  margin-left: 5.5px;
  margin-right: 5.5px;
  background: rgb(240, 242, 245);
  color: rgb(96, 98, 102);
}

#fen /deep/ .el-pager .active {
  background: rgb(1, 162, 153);
  color: rgb(255, 255, 255);
}

#fen /deep/ .el-pagination button {
  /* 上一页 */
  height: 35px;
  background: rgb(245, 245, 245);
  border-radius: 4px;
  color: rgb(0, 0, 0);
  font-family: Noto Sans SC;
  font-size: 15px;
  font-weight: 400;
  line-height: 35px;
  letter-spacing: 0px;
  text-align: center;
  padding: 0 !important;

}

/* .t /deep/ .el-pagination button,
  .t /deep/ .el-pagination li {
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  } */


#fen /deep/ .pagination input {
  /* box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25); */
  margin-top: 3px;
}

#fen /deep/ .el-pagination .more {
  /* box-shadow: none !important; */
  /* color: rgb(1, 162, 153); */
  /* margin-top: 5px; */
  background: rgb(240, 242, 245);
  width: 32px;
  height: 35px;
  border-radius:
    2px;
  /* font-size: 30px; */
  padding-top: 3px;
}

.pagination {
  margin-top: 100px;
  display: flex;
  width: 100vw;
  height: 100px;
  justify-content: center;
  gap: 11px
}

.pagination .first {
  width: 46px;
  height: 35px;
  background: rgb(1, 162, 153);
  border-radius: 4px;
  /* 首页 */
  color: rgb(255, 255, 255);
  font-family: Noto Sans SC;
  font-size: 15px;
  font-weight: 400;
  line-height: 35px;
  letter-spacing: 0px;
  text-align: center;
  cursor: pointer;
}

.pagination .txt {
  /* 共 5 页 前往 */
  width: 40px;
  height: 35px;
  color: rgb(96, 98, 102);
  font-family: Noto Sans SC;
  font-size: 15px;
  font-weight: 400;
  line-height: 35px;
  letter-spacing: 0px;
  text-align: left;
  cursor: pointer;
  transform: translateX(10px);
}

.pagination input {
  /* 选页 */
  width: 60px;
  height: 35px;
  background: rgb(255, 255, 255);
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  text-align: center;
}

.pagination .txt2 {
  /* 页 */
  width: 15px;
  height: 35px;
  color: rgb(96, 98, 102);
  font-family: Noto Sans SC;
  font-size: 15px;
  font-weight: 400;
  line-height: 35px;
  letter-spacing: 0px;
  text-align: left;
  cursor: pointer;

}

.filter .title {
  display: inline-block;
  font-size: 16px;
  font-weight: 700;
  line-height: 21px;
  transform: translateY(3px);

}

.filter {
  padding-left: 45px;
  padding-top: 15px;
  padding-bottom: 30px;
  height: 367px;
  box-sizing: border-box;

}

/deep/ .el-radio-button__inner {
  border: none !important;
  background: rgb(255, 255, 255) !important;

}

/deep/ .is-active .el-radio-button__inner {
  background: rgb(255, 255, 255) !important;
  border: none;
  font-weight: 700;
  color: rgb(42, 177, 141);
  -webkit-box-shadow: none !important;
  box-shadow: transparent !important;
}

/deep/ .el-radio-button__inner {
  border: none !important;
  background: rgb(255, 255, 255) !important;

}

/deep/ .is-checked .el-radio-button__inner {
  background: rgb(255, 255, 255) !important;
  border: none !important;
  color: rgb(42, 177, 141);
  font-weight: 700;
  -webkit-box-shadow: none !important;
  box-shadow: transparent !important;
}

/deep/ .el-radio-button span,
/deep/ .el-radio-button span {
  font-size: 16px;
  line-height: 21px;
  font-weight: 400;
  padding: 8px 5px 8px 5px;
}

.el-radio-group .title {
  transform: translateY(6px);
  padding-right: 3px;
}

#findT .box {
  width: 430px;
  height: 300px;
  background: url('../../assets/indexFTboxbg.png');
  background-size: 100% 100%;
  margin-top: 40px;
}

#findT .box .inner {
  display: flex;
  width: 360px;
  height: 212px;
  margin: 0 auto;
  margin-top: 50px;
  justify-content: space-between;
}

#findT .box .inner .left img {
  width: 120px;
  height: 180px;
}

#findT .box .inner .left .name {
  /* tag/default/default/plain/off (style) */
  width: 120px;
  height: 24px;
  box-sizing: border-box;
  border: 1px solid rgb(1, 162, 153);
  border-radius:
    2px;
  margin-top: 8px;
  /* 弗拉基米·伊里奇 */
  color: rgb(1, 162, 153);
  font-family: 苹方;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
  letter-spacing: 1px;
}

#findT .box .inner .right {
  width: 224px;
  height: 212px;
}

#findT .box .inner .right .time {
  width: 140px;
  height: 24px;
  box-sizing: border-box;
  border: 1px solid rgb(1, 162, 153);
  border-radius:
    2px;
  /* 累计授课1145h */
  color: rgb(1, 162, 153);
  font-family: 苹方;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.009999999776482582px;
  text-align: center;
}

#findT .box .inner .right .time img {
  width: 12px;
  height: 14px;
  transform: translateY(2px);
  margin-right: 5px;
}

#findT .box .inner .right .card {
  width: 224px;
  height: 20px;
  display: flex;
  gap: 8px;
  overflow: hidden;
  flex-wrap: wrap;
  margin-top: 10px;
}

#findT .box .inner .right .card div {
  width: auto;
  height: 24px;
  padding-left: 5px;
  padding-right: 5px;
  /* 下北泽大学 */
  color: rgb(1, 162, 153);
  font-family: 苹方;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
  background: rgb(207, 242, 240);
  border-radius:
    2px;

}

#findT .box .inner .right .txt {
  /* 矩形 32 */
  width: 224px;
  height: 108px;
  background: rgb(255, 255, 255);
  border: 1px dashed rgb(205, 208, 214);
  border-radius:
    2px;
  margin-top: 9px;
  padding: 4px 7px 4px 7px;
  color: rgb(96, 98, 102, 0.85);
  font-family: 苹方;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.009999999776482582px;
  text-align: justify;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  /* 限制在一个块元素显示的文本的行数 */
  -webkit-box-orient: vertical;
  /* 设置或检索伸缩盒对象的子元素的排列方式 */
  overflow: hidden;
  text-overflow: ellipsis;

}

#findT .box .inner .right button {
  width: 80px;
  height: 32px;
  background: rgb(1, 162, 153);
  border-radius: 4px;
  border: none;
  /* Small Button */
  color: rgb(255, 254, 254);
  font-family: Microsoft YaHei;
  font-size: 13px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0px;
  text-align: center;
  margin-left: 144px;
  margin-top: 8px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/find-teacher.vue